/* eslint-disable react/prop-types */
import {
  PageTitle,
  BottomButtons,
  BPReviewPanel,
  ReviewItemList, RAReviewPanel,
} from '@components';

import { Checkbox } from '@mui/material';
import { ClaimType } from '@constants';
import classes from './index.module.css';
import { useReview } from './hooks';

const TITLE = 'Please review and finish';
const CONFIRM_TEXT = 'I certify that any information I submit is truthful and accurate';

const ConfirmCheck = ({ checked, onChange }) => (
  <section className={classes.confirm_check}>
    <Checkbox
      checked={checked}
      onChange={onChange}
      color="input"
      style={{ padding: '0px' }}
    />
    <section className={classes.confirm_text}>{CONFIRM_TEXT}</section>
  </section>
);

export const Review = () => {
  const {
    files,
    type,
    orderName,
    selectedPackageList,
    isConfirmed,
    reviewData,
    isLoading,
    reasonList,
    comments,
    onClickContinue,
    handleChange,
  } = useReview();

  return (
    <section className={classes.content}>
      <PageTitle title={TITLE} />
      {type === ClaimType.RA
        ? <RAReviewPanel reviewInfo={reviewData} />
        : <BPReviewPanel reviewInfo={reviewData} />}
      <ReviewItemList
        selectedPackageList={selectedPackageList}
        orderName={orderName}
        files={files}
        comments={comments}
        type={type}
        reasonList={reasonList}
      />
      <ConfirmCheck checked={isConfirmed} onChange={handleChange} />
      <BottomButtons
        isContinueLoading={isLoading}
        isContinueDisabled={!isConfirmed}
        continueText="Submit"
        showContinueIcon={false}
        onClickContinue={onClickContinue}
      />
    </section>
  );
};
